import React, { useState } from "react";
import { db } from "../../FirebaseConfig";
import { collection, addDoc } from "firebase/firestore";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "contactMessages"), formData);
      alert("Message sent successfully!");
      setFormData({ name: "", phone: "", email: "", message: "" }); // clear form
    } catch (error) {
      alert("Error sending message: " + error.message);
    }
  };

  return (
    <>
      <form className="w-full px-4 md:px-0" onSubmit={handleSubmit}>
        <h1 className="text-center text-3xl md:text-4xl font-semibold mt-12">
          Contact Us
        </h1>

        <div className="flex flex-col w-full md:w-[60%] lg:w-[40%] mx-auto bg-white shadow-lg border border-gray-300 mt-8 rounded-xl p-6 space-y-6">
          {/* Name & Phone Inputs */}
          <div className="flex flex-col md:flex-row justify-between gap-4">
            <input
              className="border border-gray-300 rounded-md h-10 px-4 w-full"
              type="text"
              placeholder="Full Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              className="border border-gray-300 rounded-md h-10 px-4 w-full"
              type="tel"
              placeholder="Phone Number"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          {/* Email Input */}
          <input
            className="border border-gray-300 rounded-md h-10 px-4 w-full"
            type="email"
            placeholder="Email Address"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          {/* Message Textarea */}
          <textarea
            className="border border-gray-300 rounded-md px-4 py-2 h-32 w-full"
            placeholder="Your Message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>

          {/* Submit Button */}
          <button
            type="submit"
            className="bg-[#24283e] hover:bg-[#339966] transition-colors cursor-pointer text-white font-semibold rounded-full h-10 w-full"
          >
            Submit
          </button>
        </div>
      </form>
    </>
  );
}

export default ContactUs;
